import React, { useState } from 'react';
import '../styles/LegalPages.css';
import '../styles/FAQPage.css';

const faqs = [
  {
    category: 'Allgemein',
    items: [
      {
        q: 'Was ist WennWieWo?',
        a: 'WennWieWo ist eine kostenlose Schweizer Eventplattform, auf der Veranstaltungen aus der ganzen Schweiz gesammelt und übersichtlich dargestellt werden. Veranstalterinnen und Veranstalter können ihre Events eintragen, Besucherinnen und Besucher können gezielt nach Events in ihrer Region suchen.',
      },
      {
        q: 'Ist die Nutzung kostenlos?',
        a: 'Ja, WennWieWo ist für alle vollständig kostenlos — sowohl für Besucherinnen und Besucher als auch für Veranstalterinnen und Veranstalter.',
      },
      {
        q: 'Für welche Region ist WennWieWo gedacht?',
        a: 'WennWieWo richtet sich an die gesamte Schweiz. Events können für alle 26 Kantone eingetragen und nach Kanton gefiltert werden.',
      },
    ],
  },
  {
    category: 'Für Besucherinnen und Besucher',
    items: [
      {
        q: 'Muss ich ein Konto erstellen, um Events anzuschauen?',
        a: 'Nein. Alle Events auf WennWieWo sind öffentlich einsehbar — ohne Registrierung oder Anmeldung.',
      },
      {
        q: 'Wie finde ich Events in meiner Region?',
        a: 'Auf der Startseite kannst du Events nach Kanton, Datum, Kategorie und weiteren Kriterien filtern. So findest du schnell und einfach, was in deiner Nähe los ist.',
      },
      {
        q: 'Wie kann ich ein Event melden, das falsche Informationen enthält?',
        a: 'Falls du fehlerhafte oder problematische Inhalte entdeckst, melde dies bitte per E-Mail an kontakt@wennwiewo.ch. Wir prüfen den Fall und handeln entsprechend.',
      },
    ],
  },
  {
    category: 'Für Veranstalterinnen und Veranstalter',
    items: [
      {
        q: 'Wie reiche ich ein Event ein?',
        a: 'Erstelle zuerst ein kostenloses Konto. Nach der Anmeldung findest du oben in der Navigation den Button "Event einreichen". Fülle das Formular aus und sende es zur Überprüfung ein.',
      },
      {
        q: 'Wie lange dauert die Überprüfung meines Events?',
        a: 'Events werden in der Regel innerhalb von 1–3 Werktagen geprüft. Du erhältst eine Benachrichtigung in deinem Konto, sobald dein Event genehmigt oder abgelehnt wurde.',
      },
      {
        q: 'Warum wurde mein Event abgelehnt?',
        a: 'Events können abgelehnt werden, wenn sie unvollständig sind, nicht den Community-Richtlinien entsprechen oder keine reale Veranstaltung darstellen. Du erhältst eine Benachrichtigung mit dem Grund der Ablehnung und kannst das Event überarbeiten und erneut einreichen.',
      },
      {
        q: 'Kann ich ein Event nach dem Einreichen noch bearbeiten?',
        a: 'Ja. Du kannst deine Events jederzeit über dein Konto bearbeiten. Nach einer Bearbeitung wird das Event erneut zur Überprüfung eingereicht.',
      },
      {
        q: 'Was ist die Veranstalter-Verifizierung und wie beantrage ich sie?',
        a: 'Die Verifizierung kennzeichnet dich als offiziellen und vertrauenswürdigen Veranstalter auf der Plattform. Du kannst die Verifizierung in deinen Kontoeinstellungen beantragen. Nach einer Prüfung durch unser Team wird dein Profil mit einem Verifizierungsabzeichen versehen.',
      },
      {
        q: 'Kann ich mein Event löschen?',
        a: 'Ja. In der Übersicht deiner eigenen Events findest du über das Dreipunkte-Menü die Option zum Löschen. Das Löschen ist unwiderruflich.',
      },
    ],
  },
  {
    category: 'Konto & Profil',
    items: [
      {
        q: 'Wie erstelle ich ein Konto?',
        a: 'Klicke oben rechts auf "Anmelden" und dann auf "Registrieren". Gib deine E-Mail-Adresse, ein sicheres Passwort und einen Anzeigenamen ein. Nach der Registrierung bist du sofort angemeldet.',
      },
      {
        q: 'Wie ändere ich mein Passwort oder meine E-Mail-Adresse?',
        a: 'Gehe in deinen Account-Einstellungen (oben rechts auf dein Profilbild klicken) und wähle den entsprechenden Abschnitt zum Bearbeiten.',
      },
      {
        q: 'Wie lösche ich meinen Account?',
        a: 'In deinen Account-Einstellungen findest du ganz unten die Option "Account löschen". Nach Eingabe deines Passworts werden dein Konto und alle damit verknüpften Events unwiderruflich gelöscht.',
      },
    ],
  },
];

const FAQItem = ({ q, a }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={`faq-item${open ? ' faq-item--open' : ''}`}>
      <button className="faq-question" onClick={() => setOpen(!open)} aria-expanded={open}>
        <span>{q}</span>
        <svg
          className="faq-icon"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>
      {open && <div className="faq-answer"><p>{a}</p></div>}
    </div>
  );
};

const FAQPage = () => {
  return (
    <div className="legal-page">
      <div className="legal-content">
        <h1>Häufig gestellte Fragen</h1>

        {faqs.map((section) => (
          <div key={section.category} className="faq-section">
            <h2>{section.category}</h2>
            <div className="faq-list">
              {section.items.map((item) => (
                <FAQItem key={item.q} q={item.q} a={item.a} />
              ))}
            </div>
          </div>
        ))}

        <div className="faq-contact">
          <p>Deine Frage ist nicht dabei? Schreib uns: <strong>kontakt@wennwiewo.ch</strong></p>
        </div>
      </div>
    </div>
  );
};

export default FAQPage;
